import { ID } from '@griply/types';
import { useCallback } from 'react';
import { useUpdateExternalConnectionMutation } from 'shared/hooks/queries/use-update-external-connection-mutation';

export const useUpdateExternalConnectionBlacklist = () => {
  const { mutate } = useUpdateExternalConnectionMutation();

  return useCallback(
    (connectionId: ID, blacklist: ID[]) => {
      mutate({
        id: connectionId,
        settings: { calendarBlacklist: blacklist },
      });
    },
    [mutate],
  );
};
